import * as ethers from 'ethers';
import axios , {AxiosResponse} from "axios";
import { NFTInfoType } from '../../model/nftInfoJsonType';
import { NFTInfoNoneMetaType } from '../../model/nftInfoJsonNoneMetaType';
import { nftAbi } from "../../core/nftAbi";
import { v5ApiBaseUrl } from "../../core/api";
import { NFTInfoModel } from '../../model/nftInfoModel';
import { chainRPCEndpoints } from '../../core/rpcEndPoits';


//NFTミントリクエスト(Top Shot)
export const mintNFTTopShot = async(inputWalletAddress: string,walletType:string,requestId:string,meta:string) => {
  if (ethers.utils.isAddress(`${inputWalletAddress}`)) {
    let value:AxiosResponse;
    console.log(`post walletAddress ${inputWalletAddress}`);
    try {
      value = await axios.post(`${v5ApiBaseUrl}/dist/airdrop/nft-shot`, {
        requestId: requestId,
        walletAddress: inputWalletAddress,
        walletType: walletType, 
        meta: meta, 
        distributionType:`nftShot`
      })
    } catch (error) {
      alert(`${error.message}`);
      console.log(error);
      return ``;
    }
    console.log(value);

    if (value.data === `over_limit_per_wallet`) {
      // 1ウォレットあたりの配布上限に達してい場合
      return `11`;//ページ番号
    }else if(value.data === `same_request_id`){
      // リクエストIDが同じ場合
      return `13`;
    }else if(value.data === `invalid_meta`){
      // metaが正しくない場合
      return `14`;
    }else if(value.data === `out_of_minting_period`){
      // mint期間が終了している場合
      return `15`;
    }else if(value.data === `over_total_supply`){
      // コレクションの配布上限に達している場合
      return `16`;
    }

    if (walletType === `browserWallet`) {
      localStorage.setItem('walletAddressFromPK',inputWalletAddress);
      localStorage.setItem('currentStatus','browserWallet');
    }else if(walletType === `metaMask`){
      localStorage.setItem('addressofmineMM',inputWalletAddress);
      localStorage.setItem('currentStatus','metaMask');
    }
    localStorage.setItem('currentUseWalletAddress',`${inputWalletAddress}`);
    return `6`;

  }else{
    console.log(`正しくないアドレスです`);
    //⏬後々Modal表示に変更
    alert(`アドレスを正しく入力してください`);
    return ``;
  }
};
  
  
  
  



//NFT情報取得(TopShot)
export const getNFTinfoTopShotV5 = async () => {

  //①クエリパラメータから文字列を取得
  const searchParams = new URLSearchParams(window.location.search);
  console.log(location.href);
  let meta:string;

  if (window.location.href.indexOf(`http://localhost`) !== -1) {
    meta = `justtestastar`
    // meta = `justtestjoc`
    // meta = `justtestpalette`
    // meta=`1ba0310c-c426-49de-91ad-22f80b071666`

    // meta=`186df53f-0ef7-4306-b750-498ec65f0721`//unWallet用
    // meta=`5d1065d1-750e-44ff-9635-5868438c8b2e`//背景カスタマイズ用
    // meta = `86568e1a-e35f-4581-bfd5-3287684a49ab`//attributes確認用
  }else{
    meta = searchParams.get('meta') || '';
  }
  console.log(`meta : ${meta}`);

  //config.json内にmetaが設定されているか確認
  if (!meta) {
    let res:Response;

    try {
      if(window.location.href.indexOf(`http://localhost`) !== -1){
        throw new Error("Local environment is not supported");
      }
      res = await fetch(`${location.pathname.replace("index.html", "config.json")}`);
    } catch (error) {
      console.log(`not_found_json`);
    }

    if (!res) {
      return `12`;
    }

    const data = await res.json();

    if (!data.meta) {
      console.log(`not_found_meta_from_json`);
      return `12`;
    }

    meta = data.meta;
  }
  //②取得して文字列を引数に当ててバックエンドにPOST (引数に応じたnftinfo.jsonと同じフィールド値が返ってくる想定)
  let useJson : NFTInfoType;
  let value:AxiosResponse;
  try {
    value = await axios.get(`${v5ApiBaseUrl}/dist/nft-shot/nft` ,{
      params:{
        meta:meta,
      }
    });
  } catch (error) {
    //無効なmeta
    console.log(error);
    return `12`;
  }

  if (!value.data.mintable) {
    //ミント期間終了
    return `15`;
  }

  console.log(value);
  if (value) {
    const useChainInfo = chainRPCEndpoints.find((chain) => chain.chainId === `${value.data.chain.id}`);

    localStorage.setItem('currentContractAddress',`${value.data.contractaddress}`);
    localStorage.setItem('currentUseRPCEndpoint',`${useChainInfo.endpointURL}`);
    localStorage.setItem('currentUseABI',`${JSON.stringify(nftAbi)}`);
  }else{
    //NFT発行失敗
    return `14`;
  }

  let result = new NFTInfoModel(value.data);
  result.distPageConfig.meta = meta;
  return result;
}
  
  
  


